<template>
  <van-swipe ref="vantSwiper" @change="onChange" :touchable="false" :show-indicators="false" :loop="false">
    <van-swipe-item v-for="(item, index) in topicList" :key="index">
      <div class="div-txt">{{ dayDetails && dayDetails.questionTitle }}</div>
      <div class="div-imgs">
        <div class="imgs" :style="`background-image: url(${questionImage.url})`" @click="handleClickImgs">
          <img :src="questionImage && questionImage.url" style="visibility: hidden" class="imgs img-block" alt="" />
        </div>
        <div v-if="questionVideo && Object.keys(questionVideo).length > 0" class="imgs"
          :style="`background-image: url(${questionVideo.url})`" @click="handleClickQuesion">
          <img :src="questionVideo && questionVideo.url" style="visibility: hidden" class="imgs img-block" alt="" />
          <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="" />
        </div>
      </div>
      <div class="sec-block2">
        <div class="title">
          选择答案({{ dayDetails.questionType === "1" ? "单选题" : "多选题" }})
        </div>
        <div :class="['change-list', submittedReadOnly ? 'submitted-read-only' : '']" v-if="`${item.answerStatus}` === '2' && !answerForcedDisplay">
          <div :class="['item-txt', itemIds.includes(item.id) ? 'cur' : '']"
               v-for="(item, index) in dayDetails.questionOptions" :key="index" @click="handleClickItems(item.id)">
            <img src="@/assets/images/questionBank/img(23).png" v-if="itemIds.includes(item.id)" class="item-icon"
                 alt="" />
            <img src="@/assets/images/questionBank/img(25).png" v-else class="item-icon" alt="" />
            {{ item && item.optionContent }}
          </div>
        </div>
        <div class="change-list" v-if="`${item.answerStatus}` === '3' || !item.answerStatus">
          <div :class="['item-txt', itemIds.includes(item.id) && !noneHasResult ? 'cur_ok' : '']"
            v-for="(item, index) in dayDetails.questionOptions" :key="index" @click="handleClickItems(item.id)">
            <img src="@/assets/images/questionBank/qu_ok.png" v-if="itemIds.includes(item.id)" class="item-icon" alt="" />
            <img src="@/assets/images/questionBank/img(25).png" v-else class="item-icon" alt="" />
            {{ item && item.optionContent }}
          </div>
        </div>
        <div class="change-list" v-if="`${item.answerStatus}` === '1' || (`${item.answerStatus}` === '2' && answerForcedDisplay)">
          <div :class="[ 'item-txt', itemIds.includes(item.id) ? 'cur_error' : trueAnswerId.includes(item.id) && !noneHasResult ? 'cur_ok' : '']" v-for="(item, index) in dayDetails.questionOptions" :key="index" @click="handleClickItems(item.id)">
            <img src="@/assets/images/questionBank/qu_err.png" v-if="itemIds.includes(item.id)" class="item-icon"
              alt="" />
            <img src="@/assets/images/questionBank/qu_ok.png" v-else-if="trueAnswerId.includes(item.id) && !noneHasResult" class="item-icon"
              alt="" />
            <img src="@/assets/images/questionBank/img(25).png" v-else class="item-icon" alt="" />
            {{ item && item.optionContent }}
          </div>
        </div>
      </div>

      <div class="wrapper" v-if="(answerStatus !== '2' && userAnswer && userAnswer.length > 0) || answerForcedDisplay" @click.stop>
        <div class="wrapper-con">
          <div class="answer-txt true" v-if="userAnswer.length > 0 && answerIsTrue === 'true'">回答正确</div>
          <div class="answer-txt" v-if="userAnswer.length > 0 && answerIsTrue === 'false'">回答错误</div>
          <div class="true-tip-block" v-if="(userAnswer.length > 0 && !noneHasResult) || answerForcedDisplay">
            <div class="true-txt1">
              <span class="label">答案：</span>
              {{ trueTxt }}
            </div>
            <div class="true-txt1 true-txt2" v-if="dayDetails && dayDetails.remark">
              <span class="label">临床结论：</span>
              {{ dayDetails.remark }}
            </div>
            <div class="true-txt1" v-if="analysisVideo && Object.keys(analysisVideo).length > 0">
              视频解析:
              <div class="video-div" @click="handlePlayVideo">
                <img src="@/assets/images/home/bg_question1@2x.png" class="video-cover" alt="" />
              </div>
            </div>
            <div class="true-txt1" v-if="(questionCourses && questionCourses.length > 0) ||
              (questionDocuments && questionDocuments.length > 0) ||
              (questionCases && questionCases.length > 0)
              ">
              <span class="span-txt">本题知识点来源:</span>
              <div class="right-con">
                <div v-if="questionCourses.length > 0">
                  <div class="right-txt" v-for="(item, index) in questionCourses" @click="handleClick('course', item)"
                    :key="index">
                    <span class="tag-txt">课程</span>
                    <div class="title-txt">{{ item && item.courseName }}</div>
                    <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="" />
                  </div>
                </div>
                <div v-if="questionCases.length > 0">
                  <div class="right-txt" @click="handleClick('case', item)" v-for="(item, index) in questionCases"
                    :key="index">
                    <span class="tag-txt">病例</span>
                    <div class="title-txt">{{ item && item.caseDetail.title }}</div>
                    <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="" />
                  </div>
                </div>
                <div v-if="questionDocuments.length > 0">
                  <div class="right-txt" @click="handleClick('document', item)" v-for="(item, index) in questionDocuments"
                    :key="index">
                    <span class="tag-txt">文献</span>
                    <div class="title-txt">{{ item && item.documentDetail.title }}</div>
                    <img src="@/assets/images/home/icon_more@2x.png" class="icon-more" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="div-block-tips">
              该部分内容由专家提供，仅代表专家个人观点。供医疗卫生专业人士学术交流目的使用，仅供参考。临床的具体情况请以专业人士的临床诊断为准。
            </div>
          </div>
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  name: 'QuestionSwipe',
  props: {
    topicList: Array,
    dayDetails: Object,
    questionImage: Object,
    questionVideo: Object,
    itemIds: Array,
    trueAnswerId: Array,
    answerStatus: String,
    userAnswer: Array,
    answerIsTrue: String,
    trueTxt: String,
    analysisVideo: Object,
    questionCourses: Array,
    questionDocuments: Array,
    questionCases: Array,
    answerForcedDisplay: Boolean, // 强制显示答案
    submittedReadOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    noneHasResult() { // 不展示答案: path上拼接了不显示答案 noneHasResult true, 但需要在不强制显示答案的基础上, 如果强制显示答案为true, 那么还是需要显示答案的 return false
      if (this.answerForcedDisplay) {
        return false
      }
      return this.$route.query.noneHasResult
    }
  },
  methods: {
    onChange (index) {
      // Handle swipe change event
      this.$emit('swipe-change', index)
    },
    handleClickImgs () {
      // Handle image click event
      this.$emit('image-click')
    },
    handleClickQuesion () {
      // Handle question video click event
      this.$emit('question-video-click')
    },
    handleClickItems (id) {
      // Handle option item click event
      this.$emit('option-click', id)
    },
    handlePlayVideo () {
      // Handle play video click event
      this.$emit('play-video')
    },
    handleClick (type, item) {
      // Handle course/case/document click event
      this.$emit('resource-click', { type, item })
    }
  }
}
</script>
<style lang="less" scoped>
.sec-block2 {
  .title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding-left: 8px;
    box-sizing: border-box;
    line-height: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      position: absolute;
      width: 4px;
      left: 0;
      top: 4px;
      height: 12px;
      border-radius: 100px;
      background-color: #EB1700;
      content: "";
    }
  }
}
.div-imgs {
  margin-bottom: 16px;

  .imgs {
    width: 100%;
    display: block;
    margin-top: 10px;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .img-block {
      pointer-events: none;
    }
  }

  .icon-play {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.change-list {
  &.submitted-read-only {
    pointer-events: none;
  }

  .item-txt {
    width: 100%;
    margin-bottom: 13px;
    background-color: #f5f5f5;
    border-radius: 20px;
    font-size: 14px;
    color: #333333;
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    &.cur {
      color: #EB1700;
    }

    &.cur_ok {
      color: #328714;
    }

    &.cur_error {
      color: #EB1700;
      border: 1px solid #EB1700;
    }

    .item-icon {
      width: 17px;
      height: 17px;
      display: block;
      margin-right: 12px;
    }
  }
}

.wrapper {
  z-index: 9;
  bottom: 0;
  background-color: #fff;
  padding-top: 0;

  .title-bar-view {
    padding-top: 24px;
    padding-bottom: 15px;
    position: sticky;
    top: 0;
    background-color: #fff;
    margin-bottom: 0;
    box-sizing: border-box;
    z-index: 9;
  }

  .wrapper-con {
    box-sizing: border-box;
  }

  .change-list {
    .item-txt {
      width: 100%;
      margin-bottom: 13px;
      background-color: #f5f5f5;
      border-radius: 20px;
      font-size: 14px;
      color: #333333;
      padding: 10px 20px;
      box-sizing: border-box;

      &.cur {
        background-color: #EB1700;
        color: #ffffff;
      }
    }
  }

  .answer-txt {
    font-size: 14px;
    color: #EB1700;
    text-align: center;

    &.true {
      color: #328714;
    }
  }

  .wrapper-btn {
    width: 352px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    background-color: #EB1700;
    border-radius: 100px;
    font-size: 14px;
    color: #ffffff;
  }

  .true-tip-block {
    background-color: #f5f6f8;
    padding: 10px 16px;
    box-sizing: border-box;
    margin-top: 16px;

    .true-txt1 {
      font-size: 14px;
      color: #6a7481;
      font-weight: 500;
      margin-bottom: 16px;
      line-height: 20px;
      display: flex;
      flex-wrap: wrap;

      &.true-txt2 {
        max-height: 140px;
        overflow-y: auto;
      }

      .label {
        font-size: 14px;
        color: #313235;
        font-weight: 600;
      }

      .span-txt {
        width: 100%;
        display: block;
        color: #313235;
        font-weight: 600;
      }

      .right-con {
        width: 100%;

        .right-txt {
          display: flex;
          align-items: center;
          width: 100%;
          height: 38px;
          margin-top: 8px;
          background: rgba(255, 91, 12, 0.08);
          justify-content: space-between;
          padding-left: 12px;
          padding-right: 8px;
          box-sizing: border-box;
          border-radius: 4px;

          .tag-txt {
            width: 30px;
            height: 16px;
            border-radius: 4px;
            background-color: #EB1700;
            font-size: 12px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
          }

          .title-txt {
            font-size: 14px;
            color: #EB1700;
            width: 220px;
            white-space: nowrap;
            overflow: hidden;
            display: block;
            text-overflow: ellipsis;
          }

          .icon-more {
            width: 16px;
            height: 16px;
            display: block;
          }
        }
      }

      .video-div {
        position: relative;
        width: 137px;
        height: 72px;
        display: block;
        margin-left: 20px;

        .video-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .icon-play {
          width: 23px;
          height: 23px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .div-block-tips {
    margin-left: 50%;
    transform: translateX(-50%);
    background-color: #edeef5;
    border-radius: 4px;
    color: #6a7481;
    font-size: 10px;
    line-height: 20px;
    width: 100%;
    margin-top: 18px;
    padding: 10px 12px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionCom/itemComponents.vue